import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import styles from './styles';

const Title = ({ title, subtitle, classes }) => (
  <React.Fragment>
    <div className={classes.wrapper}>
      <Typography id="clear" className={classes.title}>
        {title}
      </Typography>
      {subtitle !== '' ? (
        <Typography id="clear" className={classes.subtitle}>
          {subtitle}
        </Typography>
      ) : null}
    </div>
  </React.Fragment>
);

Title.propTypes = {
  classes: PropTypes.any.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

Title.defaultProps = {
  title: '',
  subtitle: '',
};

export default withStyles(styles)(Title);
